import styled from "styled-components";

export const SpinnerContainer = styled.div`
  width: 100vw;
`;

export const StyledSpinner = styled.div`
  width: ${(props) => props.width || "64px"};
  height: ${(props) => props.height || "64px"};
  border: 8px solid;
  border-color: #999999 transparent #cccccc transparent;
  border-radius: 50%;
  animation: spin 1.2s linear infinite;
  margin: 50px auto;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
